const state = {
    measure_units: [],
    measure_unit: {},
    measure_unit_filters: {},
}

export default state;
